var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 25 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14283 9.72768C8.12776 9.72768 8.92855 8.9269 8.92855 7.94196V6.15625H5.35712V7.94196C5.35712 8.9269 6.15846 9.72768 7.14283 9.72768Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.72768C13.4849 9.72768 14.2857 8.9269 14.2857 7.94196V6.15625H10.7143V7.94196C10.7143 8.9269 11.5156 9.72768 12.5 9.72768Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57143 7.94196V6.15625H0V7.94196C0 8.9269 0.801339 9.72768 1.78571 9.72768C2.77009 9.72768 3.57143 8.9269 3.57143 7.94196Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 9.72768C18.8421 9.72768 19.6428 8.9269 19.6428 7.94196V6.15625H16.0714V7.94196C16.0714 8.9269 16.8728 9.72768 17.8571 9.72768Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 7.94196C21.4286 8.9269 22.2299 9.72768 23.2143 9.72768C24.1987 9.72768 25 8.9269 25 7.94196V6.15625H21.4286V7.94196Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 0H1.43749L0.270081 4.37054H24.7299L23.5625 0Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5357 10.3019C19.8806 11.0441 18.9225 11.5134 17.8572 11.5134C16.7919 11.5134 15.8337 11.0441 15.1786 10.3019C14.5235 11.0446 13.5653 11.5134 12.5 11.5134C11.4347 11.5134 10.4766 11.0441 9.82145 10.3019C9.16631 11.0446 8.20872 11.5134 7.14287 11.5134C6.07703 11.5134 5.11944 11.0441 4.4643 10.3019C3.97825 10.8532 3.32479 11.2528 2.58484 11.423V21.1735C2.58484 22.0658 3.31084 22.7918 4.20314 22.7918H8.74109V16.6356C8.74109 15.1066 9.98495 13.8633 11.5134 13.8633H13.4872C15.0162 13.8633 16.2601 15.1071 16.2601 16.6356V22.7918H20.798C21.6903 22.7918 22.4163 22.0658 22.4163 21.1735V11.423C21.6764 11.2533 21.0229 10.8532 20.5368 10.3019H20.5357Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4866 15.6484H11.5129C10.9688 15.6484 10.5257 16.091 10.5257 16.635V22.7913H14.4732V16.635C14.4732 16.091 14.0307 15.6484 13.4861 15.6484H13.4866Z",
    fill: "#484888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_1571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 22.7913,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.0e921905b2b951e974ca8ec8a1fe913f.svg";
export { ForwardRef as ReactComponent };